import { ArrowRight, ArrowUpRight } from "lucide-react";
import PageHeader from "@/components/site/PageHeader";
import LeadDialog from "@/components/site/LeadDialog";
import { SOLUTIONS } from "@/data/site";

export default function Solutions() {
  return (
    <main data-testid="solutions-page">
      <PageHeader
        overline="Solutions"
        title="Platforms that power how modern companies operate"
        subtitle="From CRM and ERP to AI assistants and analytics — proven blueprints tailored to your business."
        testid="solutions-page-header"
      />

      <section className="py-12 md:py-16">
        <div className="container-zx grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SOLUTIONS.map((s) => (
            <div key={s.title} className="card-surface p-7 group" data-testid={`solutions-card-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <div className="flex items-center justify-between">
                <div className="h-11 w-11 rounded-lg grid place-items-center bg-cyan/10 border border-cyan/25 text-cyan">
                  <s.icon className="h-5 w-5" />
                </div>
                <ArrowUpRight className="h-4 w-4 text-ink-400 group-hover:text-cyan transition" />
              </div>
              <h3 className="mt-5 text-lg font-semibold text-white">{s.title}</h3>
              <p className="mt-2 text-sm text-ink-400 leading-relaxed">{s.blurb}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-16 md:py-24 bg-[#050F1C]/60 border-y border-white/[0.04]">
        <div className="container-zx text-center max-w-3xl mx-auto">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-white">Don&apos;t see exactly what you need?</h2>
          <p className="mt-4 text-ink-200">Most of what we build is custom. Tell us about your operating model and we&apos;ll come back with a tailored architecture.</p>
          <LeadDialog
            source="solutions_page"
            titleVariant="consultation"
            trigger={
              <button type="button" className="btn-primary mt-8" data-testid="solutions-cta">
                Start a conversation <ArrowRight className="h-4 w-4" />
              </button>
            }
          />
        </div>
      </section>
    </main>
  );
}
